/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("CarsToRetailController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "Blob", "FileSaver", "$user", "$oidc", "$translate", "$notifications",
            function ($scope, $http, $sessionStorage, $uibModal, Blob, FileSaver, user, oidc, translate, notifications) {

                $scope.$storage = $sessionStorage;
                $scope.user = user;

                $scope.list = [];

                $scope.load = function () {
                    return $http
                        .get("/api/retail/units-to-retail", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        }, function () {
                            $scope.list = [];
                        });
                };

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $scope.load();
                    }
                });

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.carsToRetail.orderName === orderName) {
                        $scope.$storage.carsToRetail.orderDesc = !$scope.$storage.carsToRetail.orderDesc;
                    } else {
                        $scope.$storage.carsToRetail.orderName = orderName;
                        $scope.$storage.carsToRetail.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.carsToRetail.orderName === orderName) {
                        if ($scope.$storage.carsToRetail.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                // Set delivery date
                $scope.setDeliveryDate = function (item) {
                    $uibModal.open({
                        template: require("./CarsToRetailSetDeliveryDate.html"),
                        controller: "CarsToRetailSetDeliveryDateController",
                        resolve: {
                            unit: function () {
                                return item;
                            },
                            country: function () {
                                return $scope.retailer.CountryCode;
                            }
                        }
                    }).result.then(function () {
                        $scope.load();
                        if ($scope.retailer.CountryCode !== "HUN") {
                            return _downloadFile(item.VIN);
                        }
                    }, function () { });
                };

                function _downloadFile(vin) {
                    return $http.get("/api/service-tag/" + vin + "/download", {
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        skipInterceptors: true
                    })
                        .then(function (response) {
                            var contentDisposition = response.headers("content-disposition");
                            var regex = /filename="*([^"].+[^"])"*;/g;
                            var result = regex.exec(contentDisposition);
                            var fileName = result[1];
                            var data = new Blob([response.data], { type: response.headers("content-type") });
                            FileSaver.saveAs(data, fileName);
                        }, function (data) {
                            translate(['ServiceTagAttachmentDownloadError.Message', 'ServiceTagAttachmentDownloadError.Name'])
                                .then(function (translations) {
                                    notifications.addError(
                                        translations['ServiceTagAttachmentDownloadError.Name'],
                                        translations['ServiceTagAttachmentDownloadError.Message']
                                    );
                                }, function () {
                                    notifications.addError(
                                        'Error',
                                        'An error occured when downloading attachments'
                                    );
                                })
                        });
                }


                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.load();
                }
            }
        ]);

})();
